import { Input } from '../../ui';
import { useFieldContext } from '../FieldContext';

export function EmailInput() {
  const { field, value, onChange, readOnly } = useFieldContext();
  return (
    <Input
      type="email"
      inputMode="email"
      autoCapitalize="none"
      spellCheck={false}
      value={typeof value === 'string' ? value : ''}
      onChange={(event) => onChange(event.target.value)}
      disabled={readOnly}
      aria-label={field.label}
      placeholder="name@example.com"
    />
  );
}
